var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n\t000\n\t"),_c('button',{on:{"click":_vm.code0001}},[_vm._v("获取验证码")])])}
var staticRenderFns = []

export { render, staticRenderFns }